<template>
  <div>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <vx-card>
          <h1>{{obj}}</h1>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LIcon } from "vue2-leaflet";

export default {
  data: () => ({
    dataObj: "",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
    zoom: 5 ,
    center: [41.33803536103302, 66.54790741124002],
    bounds: null,
    obj: null,
    objectsList :[],
  }),
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LIcon,
  },

  async created() {
    await this.$store
      .dispatch("objects/fetchAllCompanyObject")
      .then(res => {
        this.objectsList.push(...this.$store.state.objects.objects);
        // this.Map_Eco_data.push(...this.$store.state.objects.objects);
        console.log(this.markers);
      })
      .catch(err => {
        console.error(err);
      });
    this.obj = this.objectsList.find(
      (o) => o.object_id === Number(this.$route.params.id)
    );
    // this.obj = this.Map_Eco_data.find(
    //   (o) => o.object_id === Number(this.$route.params.id)
    // );
  },
  mounted(){
    this.dataObj = this.obj;
    console.log("this.dataObj");
    console.log(this.dataObj);
    console.log("this.dataObj");
    this.center[0] = this.dataObj.coord_E;
    this.center[1] = this.dataObj.coord_N;
  },

  methods: {
    zoomUpdated(zoom) {
      this.zoom = zoom;
    },
    centerUpdated(center) {
      this.center = center;
    },
    boundsUpdated(bounds) {
      this.bounds = bounds;
    },
  },
};
</script>


